import React from 'react';
import { motion } from 'framer-motion';

const publicUrl = process.env.PUBLIC_URL || '';

const partners = [
  { name: 'Microsoft', image: `${publicUrl}/images/microsoft-cloud.jpg` },
  { name: 'Kaspersky', image: `${publicUrl}/images/kaspersky.png` },
  { name: 'Red Dot Distribution', image: `${publicUrl}/images/reddot.png` },
  { name: 'Odoo', image: `${publicUrl}/images/odoo.png` },
  { name: 'Liquid', image: `${publicUrl}/images/liquid.png` },
  { name: 'ICTAZ', image: `${publicUrl}/images/ictaz.png` }
];

export default function Partners() {
  return (
    <section id="partners" style={{ padding: '8rem 2rem', background: 'linear-gradient(180deg, transparent, rgba(255,107,0,0.01), transparent)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{ textAlign: 'center', marginBottom: '4rem' }}
        >
          <span style={{
            display: 'inline-block', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.14em',
            textTransform: 'uppercase', color: 'var(--text)', marginBottom: '1rem',
            padding: '0.3rem 0.9rem', borderRadius: 100,
            background: 'var(--electric-dim)', border: '1px solid var(--gray-light)',
          }}>Partnerships</span>
          <h2 style={{ fontSize: 'clamp(1.8rem, 3.5vw, 2.75rem)', letterSpacing: '-0.02em', color: 'var(--text)' }}>
            Industry <span style={{ color: 'var(--orange)' }}>Affiliations</span>
          </h2>
          <p style={{ fontSize: '1rem', color: 'var(--text-soft)', marginTop: '1rem' }}>
            We partner with globally recognized technology leaders to deliver best-in-class solutions.
          </p>
        </motion.div>

        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '2rem', maxWidth: 1200, margin: '0 auto' }}>
          {partners.map((p, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              style={{
                width: 280,
                padding: '2rem', textAlign: 'center',
                background: 'rgba(255,255,255,0.5)',
                border: '1px solid var(--gray-light)',
                borderRadius: 20,
                transition: 'all 0.3s',
                height: 200,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                userSelect: 'none',
                WebkitUserSelect: 'none',
              }}
            >
              <img 
                src={p.image} 
                alt={p.name}
                style={{
                  maxWidth: '80%',
                  maxHeight: '80%',
                  objectFit: 'contain',
                }}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
